import React, { useState, useEffect } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { useTranslation } from "react-i18next";
import MuiAlert, { AlertColor } from '@mui/material/Alert';
import { useNavigate, useParams } from "react-router-dom";
import { IComboBoxOption, Panel } from '@fluentui/react';
import {
    ValidationRuleVOActivity,
    ValidationRuleVOCreateUpdate,
    ValidationTypes
} from "../../../model/ValidationRuleModel";
import { CreateVr, GetOneVr, GetValidationTypes, GetVrByWorkspaceId, UpdateVr } from '../../../services/ValidationRuleService';
import { GetOptions } from "../ResponsabilityReturn/ReturnCombo";

import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { AccountTree, Check } from '@mui/icons-material';
import { Button, Snackbar, Typography } from '@mui/material';
import { MaxValidationRuleIcon } from '../../../assets/icons/MaxValidationRuleIcon';
import MessageComp from '../../../components/Dialog/Message';
import { PaywallModal } from '../../../components/PaywallModal/PaywallModal';
import { GetOneOrganization } from '../../../services/OrganizationServices';
import { ValidationRuleActivity } from './ValidationRuleActivity';
import { ValidationRuleLowerTitle } from './components/ValidationRuleLowerTitle';
import { ValidationRuleActionHeader } from './components/ValidationRuleActionHeader';
import { ValidationRuleTableContainer } from './components/ValidationRuleTableContainer';
import { ValidationRuleTableTitle } from './components/ValidationRuleTableTItle';
import { ValidationRuleTableBody } from './components/ValidationRuleTableBody';
import { KeyDrivePageContainer } from "../../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer";

const ValidationRuleCreateEdit = (props: any) => {
    const { nameOrg } = useParams();
    const { idWorkspace } = useParams();
    const { idValidationRule } = useParams();
    const { t } = useTranslation();
    const [idVr, setIdVr] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [popupOk, setPopupOk] = useState<boolean>(false);
    const [popupError, setPopupError] = useState<boolean>(true);
    const [descriptionNewActivity, setDescriptionNewActivity] = useState<string>("");
    const [lastActivityId, setLastActivityId] = useState<number>(-1);
    const navegate = useNavigate();
    const [activity, setActiviy] = useState<ValidationRuleVOActivity[]>([]);
    const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
        useBoolean(false);
    const [validateNewEdit, setValidateNewEdit] = useState<ValidationRuleVOActivity | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState<string>(t("ErroAoSalvar.message"));
    const [alertColor, setAlertColor] = useState<AlertColor>("success");
    const [options, setOptions] = useState<IComboBoxOption[] | undefined>(undefined);
    const [menuItems, setMenuItems] = useState<IContextualMenuItem[]>([]);
    const [validationTypes, SetValidationTypes] = useState<ValidationTypes[]>([]);
    const linkRef = React.useRef(null);
    const [rowsSelected, setRowsSelected] = useState<number[]>([]);
    const [isMoveUp, setIsMoveUp] = useState<boolean>(false);
    const [selectedVr, setSelectedVr] = useState<ValidationRuleVOActivity>({} as ValidationRuleVOActivity);
    const [showContextualMenu, setShowContextualMenu] = React.useState(false);
    const onShowContextualMenu = React.useCallback((ev: React.MouseEvent<HTMLElement>) => {
        ev.preventDefault();
        setShowContextualMenu(true);
    }, []);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [openPaywall, setOpenPaywall] = useState<boolean>(false);
    const [validationRuleMaxLimit, setValidationRuleMaxLimit] = useState<boolean>(false);


    const handleClose = (event: any, reason: any) => {
        setPopupOk(false);
    }

    const handleClosePO = (event: any) => {
        setPopupOk(false);
    }

    const updatePanel = () => {
        setValidateNewEdit(undefined);
        dismissPanel();
    };

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, vr: ValidationRuleVOActivity) => {
        setSelectedVr(vr);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const onClickEdit = (validationRuleVOActivity: ValidationRuleVOActivity) => {
        setValidateNewEdit(validationRuleVOActivity);
    };

    const onClickDelete = (parameters: number[]) => {
        parameters.forEach(param => {
            const indexList = activity.findIndex(x => x.id == param)
            if (indexList != undefined) {
                if (indexList > -1) {
                    activity.splice(indexList, 1);
                    const newListVR = [...activity];
                    setActiviy(newListVR);
                }
            }
        });
    };

    useEffect(() => {
        if (validateNewEdit != undefined) {
            openPanel();
        }
    }, [validateNewEdit]);

    useEffect(() => {
        let context: IContextualMenuItem[] = [];

        validationTypes.forEach(validationType => {
            context.push({
                key: validationType.index,
                text: validationType.name,
                onClick: addNew
            });
        });

        setMenuItems(context);
    }, [lastActivityId, validationTypes]);

    useEffect(() => {
        if (idWorkspace !== undefined && nameOrg !== undefined) {
            let vrQuantity: number;

            GetVrByWorkspaceId(idWorkspace, 0, 1000)
                .then((newWork) => {
                    vrQuantity = newWork.length;

                    return GetOneOrganization(nameOrg);
                })
                .then((org) => {
                    if (org && org.contractStatus === 3 && vrQuantity >= 1) {
                        setValidationRuleMaxLimit(true);
                    } else {
                        setValidationRuleMaxLimit(false);
                    }
                })
                .catch((err) => {
                    setErrorMessage(t("Paywall.error"));
                    setAlertColor("warning");
                    setPopupOk(true);
                });
        }
    }, [idWorkspace, nameOrg]);


    function addNew(ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) {
        ev && ev.preventDefault();

        setValidationRuleMaxLimit((prevLimit) => {
            if (prevLimit) {
                setOpenPaywall(true);
                return prevLimit;
            }

            if (item?.text == undefined) {
                setDescriptionNewActivity(t("ValidationRules.NewActivity"));
            } else {
                setDescriptionNewActivity(t("New.female") + " " + item?.text);
            }

            let newValidationRuleVOActivity: ValidationRuleVOActivity = {
                id: lastActivityId + 1,
                order: lastActivityId + 1,
                name: "",
                type: item?.key.toString(),
                responsability: [],
                deleted: false,
            };

            setValidateNewEdit(newValidationRuleVOActivity);
            return prevLimit;
        });
    }

    useEffect(() => {

        if (nameOrg != undefined) {
            GetOptions(t, nameOrg)
                .then((response) => {
                    setOptions(response);
                })

            GetValidationTypes(nameOrg)
                .then((result) => {
                    SetValidationTypes(result);
                })
                .catch((error) => {
                });

            if (idValidationRule != undefined && idValidationRule != "new") {
                GetOneVr(idValidationRule)
                    .then((result) => {
                        setIdVr(idValidationRule);

                        if (result.name) {
                            setName(result.name);
                        }

                        if (result.description) {
                            setDescription(result.description);
                        }

                        if (result.lastActivityId != undefined) {
                            setLastActivityId(result.lastActivityId);
                        }

                        if (result.activity) {
                            setActiviy(result.activity);
                        }
                    })
                    .catch((error) => {
                        setPopupError(false);
                    });
            }
            else {
                setIdVr(undefined);
            }
        }
    }, [idValidationRule, nameOrg]);


    function crudValidationRulle(returnValidation: ValidationRuleVOActivity) {
        console.log(returnValidation)
        if (returnValidation.id != undefined) {
            var found = activity.find(x => x.id == returnValidation.id);
            if (found != undefined) {
                let index = activity.indexOf(found);
                if (index == -1) {
                    setLastActivityId(returnValidation.id)
                    setActiviy([...activity, returnValidation]);
                }
                else {
                    let act = [...activity];
                    act[index] = returnValidation;
                    setActiviy(act);

                }
            }
            else {
                setLastActivityId(returnValidation.id);
                setActiviy([...activity, returnValidation]);
            }
        }

        setValidateNewEdit(undefined);
        dismissPanel();
    }

    function closePopUpOk() {
        setPopupError(true);
        navegate("/");
    }

    function saveVr() {
        let vr: ValidationRuleVOCreateUpdate = {
            name: name,
            description: description,
            activity: activity,
            workSpaceId: idWorkspace
        }

        setErrorMessage(t("ValidationRule.saveOk"));
        setAlertColor("success");

        if (idVr != undefined) {
            vr.id = idVr;
            UpdateVr(vr)
                .then((response) => {
                    setPopupOk(true);
                })
                .catch((error) => {
                    if (error.response && error.response.data && typeof error.response.data === 'string') {
                        setErrorMessage(error.response.data);
                    }
                    else {
                        setErrorMessage(t("ErroAoSalvar.message"));
                    }

                    setAlertColor("error");
                    setPopupOk(true);
                });
        }
        else {
            CreateVr(vr)
                .then((response) => {
                    setIdVr(response);
                    setPopupOk(true);
                })
                .catch((error) => {
                    if (error.response && error.response.data && typeof error.response.data === 'string') {
                        setErrorMessage(error.response.data.toString());
                    }
                    else {
                        setErrorMessage(t("ErroAoSalvar.message"));
                    }
                    setAlertColor("error");
                    setPopupOk(true);
                });
        }
    }

    console.log(validateNewEdit)

    return (
        <KeyDrivePageContainer
            icon={<AccountTree fontSize='large' sx={{ color: "#22638D" }} />}
            title={t("ValidationRule.newValidationRule")}
            actions={<Button
                startIcon={<Check />}
                variant='contained'
                sx={{
                    background: "#22638D 0% 0% no-repeat padding-box",
                    borderRadius: "4px",
                    opacity: 1,
                }}
                onClick={saveVr}
            >
                <Typography
                    textTransform="none"
                    sx={{
                        textAlign: "left",
                        font: "normal normal 600 14px/21px Segoe UI",
                        letterSpacing: "0px",
                        color: "#FFFFFF",
                        opacity: 1,
                    }}
                >
                    {t("ValidationRule.saveValidationRule")}
                </Typography>
            </Button>}
            divider
        >
            <ValidationRuleLowerTitle
                description={description}
                name={name}
                setDescription={setDescription}
                setName={setName}
            />
            <ValidationRuleActionHeader
                addNew={addNew}
                onClickDelete={onClickDelete}
                rowsSelected={rowsSelected}
            />
            <ValidationRuleTableContainer>
                <ValidationRuleTableTitle />
                <ValidationRuleTableBody
                    activity={activity}
                    anchorEl={anchorEl!}
                    handleMenuClose={handleMenuClose}
                    handleMenuOpen={handleMenuOpen}
                    rowsSelected={rowsSelected}
                    setRowsSelected={setRowsSelected}
                    onClickEdit={onClickEdit}
                    selectedVr={selectedVr}
                />
            </ValidationRuleTableContainer>
            <Panel
                isOpen={isOpen}
                closeButtonAriaLabel={t("Fechar.message")}
                onDismiss={updatePanel}
                isFooterAtBottom={true}
                styles={{
                    main: {
                        width: "500px !important"
                    }
                }}
            >
                {nameOrg != undefined && validateNewEdit != undefined && (
                    <ValidationRuleActivity
                        nameOrg={nameOrg}
                        validateNewEdit={validateNewEdit}
                        returnValidation={crudValidationRulle}
                    />
                )}
            </Panel>

            <MessageComp
                hidden={popupError}
                title={t("ValidationRule.errorFind")}
                closeButtonAriaLabel={t("Fechar.message")}
                buttonMethod={closePopUpOk}
                text={t("Continuar.message")}
            />

            <Snackbar
                open={popupOk}
                autoHideDuration={6000}
                message="Archived"
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                sx={{ bottom: { xs: 50, sm: 20 } }}
            >
                <MuiAlert elevation={6} variant="filled" sx={{ width: '100%' }} severity={alertColor} onClose={handleClosePO}>
                    {errorMessage}
                </MuiAlert>
            </Snackbar>

            <PaywallModal open={openPaywall} icon={<MaxValidationRuleIcon />} setOpen={setOpenPaywall} subtitleStart={t("Paywall.validationRuleStart")} subtitleBold={t("Paywall.validationRuleBold")} subtitleEnd={t("Paywall.validationRuleEnd")} />
        </KeyDrivePageContainer>
    );
}

export default ValidationRuleCreateEdit;